<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="text-center p-4" v-if="!detail">กำลังโหลด</div>
    <div class="wrapper" v-else>
      <div class="row">
        <div class="col-3 member">
          <p
            class="font-red"
            v-if="subscriber.isUserForOfflinePurchaseByAdmin === true"
          >*ซื้อนอกระบบลูกค้าไม่โหลด App</p>
          <p>ชื่อ</p>
          <h6>{{ subscriber.name }}</h6>
          <p>บ้านเลขที่</p>
          <h6>{{ subscriber.home.addressNumber }}</h6>
          <p>โครงการ</p>
          <h6>{{ subscriber.home.project }}</h6>
          <p>เบอร์โทรศัพท์</p>
          <h6>{{ subscriber.phoneNumber }}</h6>
          <p>E-mail</p>
          <h6>{{ subscriber.email }}</h6>
          <p>เลขบัตรประชาชน / Passport No.</p>
          <div class="mb-3">
            <button
              v-if="!isButtonHidden"
              class="button-content"
              @click="handleDecryptIdCard"
            >
              <span style="font-weight: bold">แสดงข้อมูล</span>
              <i class="fa fa-eye-slash" aria-hidden="true"></i>
            </button>
            <div v-if="subscriber.identifierNo" class="identifier-id">
              {{ subscriber.identifierNo }}
            </div>
         </div>
          <p>วันเกิด</p>
          <h6>{{ subscriber.dateOfBirth }}</h6>
        </div>
        <div class="col-9 info">
          <p>แพ็กเกจ</p>
          <h6>
            {{ subscriber.package.name }}
            <br />
            <small>{{ subscriber.package.billingCycle }}</small>
            <br />
            <small>{{ subscriber.qualityText }}</small>
          </h6>
          <p>บริการ</p>
          <div v-for="(service, serviceIndex) in services" :key="serviceIndex">
            <service-list-item
              class="service-item"
              :key="service.id"
              v-bind="service.data"
              :qualityUnit="subscriber.qualityUnit"
            ></service-list-item>
            <div
              v-for="(history, historyIndex) in Object.keys(service.histories)
              .sort((a, b) => (b.invoice > a.invoice ? 1 : -1))"
              :key="history">
              <p v-if="history!=='null'">
                <b>รอบบิลที่:</b> {{ Object.keys(service.histories).length - historyIndex }}
                &nbsp; Invoice: {{history.toString().padStart(12, "0")}}
                &nbsp; ซื้อเมื่อ: {{service.histories[history][0].purchasedAt | date}}
                &nbsp; มีผลเมื่อ: {{service.histories[history][0].effectivedAt | date}}
                &nbsp; เลขใบเสร็จ: {{service.histories[history][0].documentNumber}}
                </p>
                <p
                  v-if="service.histories[history][0].isDisableAppointmentByNoteInvoice"
                  class="mb-3 font-red"
                >* มีการปิดไม่ให้นัดหมายใน รอบบิล นี้</p>
              <div
                v-for="(appointment, appointmentIndex) in service.histories[history]"
                :key="appointmentIndex"
                class="align-items-center mb-3"
              >
                <div class="row appointment-title">
                  <div class="col-lg-2">นัดหมาย</div>
                  <div class="col-lg-3" v-if="!appointment.canMakeAppointment">วันที่</div>
                  <div class="col-lg-2" v-if="!appointment.canMakeAppointment">ผู้ให้บริการ</div>
                  <div class="col-lg-2" v-if="!appointment.canMakeAppointment">ราคาต้นทุนจริง</div>
                </div>
                <div class="row">
                  <div class="col-lg-2">ครั้งที่ {{ (appointment.appointmentNo!==null)? appointment.appointmentNo : appointmentIndex + 1 }}</div>
                  <div class="d-flex flex-row col-lg-3" v-if="!appointment.canMakeAppointment">
                    <div class="mr-1">{{ appointment.date }}</div>
                    <div v-show="!isFastFixServiceType(service.data.type)">
                      - {{ appointment.time }}
                    </div>
                  </div>
                  <div class="col-lg-2" v-if="!appointment.canMakeAppointment">
                    <el-select
                      class="provider-selector"
                      :value="appointment.providerId"
                      @input="handleChangeProvider(
                        appointment.id,
                        $event,
                        appointment.actualCost
                      )"
                      filterable
                      placeholder="เลือกผู้ให้บริการ"
                      remote
                      :disabled="appointment.canNotEditAppointmentCost"
                    >
                      <el-option
                        v-for="item in providers"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                        <div class="provider-option">
                          <img class="icon" :src="item.logoUrl" />
                          <div class="name">{{ item.name }}</div>
                        </div>
                      </el-option>
                    </el-select>
                  </div>
                  <div class="col-lg-2" v-if="!appointment.canMakeAppointment">
                    <input
                      :disabled="appointment.canNotEditAppointmentCost"
                      type="text"
                      class="form-control"
                      :value="appointment.actualCost"
                      @input="handleEditActualCost(
                        service.id,
                        appointment.id,
                        $event.target.value
                      )"
                      @keyup.enter="handleEnterEditActualCost(
                        appointment.id,
                        appointment.actualCost,
                        appointment.providerId
                      )"
                      placeholder="Enter เพื่อบันทึก"
                    >
                  </div>
                  <div class="col-lg-2">
                    <sc-button
                      variant="secondary"
                      size="sm"
                      v-if="!appointment.canMakeAppointment"
                      :route="appointment.route"
                      >ดูข้อมูล</sc-button
                    >
                    <sc-button
                      variant="primary"
                      size="sm"
                      v-else-if="appointment.canMakeAppointment"
                      :disabled="appointment.isDisableButton"
                      @click="handleClickBookService(service, appointment)"
                      >นัดวัน</sc-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
    <confirm
      :data="confirmDialog"
      v-if="confirmDialog.isShow"
      @confirm="handleConfirm"
    >
      <div class="mb-3">
        <date-picker
          :value="form.dateTime"
          @input="handleChangeDateTime"
          class="mb-2 w-100"
        ></date-picker>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="label mb-2">เวลาที่เริ่ม</div>
          <el-time-picker
            :value="form.timeStart"
            @input="handleChangeTime($event, 'START')"
            class="mb-2"
            format="HH:mm"
            type="time"
          ></el-time-picker>
        </div>
        <div  class="col-6">
          <div class="label mb-2">เวลาที่สิ้นสุด (Optional)</div>
          <el-time-picker
            :value="form.timeEnd"
            @input="handleChangeTime($event, 'END')"
            class="mb-2"
            format="HH:mm"
            type="time"
          ></el-time-picker>
        </div>
      </div>
    </confirm>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import {
  Select as ElSelect,
  Option as ElOption,
  TimePicker as ElTimePicker,
  Input as ElInput
} from "element-ui";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import { toLocaleTH, getDurationAppointmentTimeText } from "@/lib/dateTime";
import { reversePaymentStatus, subscriptionStatus } from "@/lib/mapper";
import ServiceListItem from "../../services/components/ServiceListItem";
import DatePicker from "@/lib/components/DatePicker";
import { toCamelCaseObject, existValueAndEmptyString } from "@/lib/util";
import { uuid } from "vue-uuid";
import {
  convertBathToStangAndRoundTwoDecimal,
  convertStangToBathAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";
import { backendAdminClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ScButton,
    ServiceListItem,
    ElSelect,
    ElOption,
    DatePicker,
    ElTimePicker,
    ElInput
  },
  data() {
    const title = "รายละเอียดสมาชิก";
    const confirmDialog = {
      isShow: false,
      title: "นัดวัน",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: true
    };

    return {
      title,
      detail: null,
      subscriber: null,
      histories: [],
      appointmentById: {},
      confirmDialog,
      form: {
        service: null,
        dateTime: null,
        timeStart: null,
        appointment: null,
        timeEnd: null
      },
      providers: [],
      decryptedId: null,
      isButtonHidden: false
    };
  },

  computed: {
    services() {
      return this.detail.services.map(service => {
        const {
          id,
          name,
          short_description: shortDescription,
          description,
          icon: iconUrl,
          quota,
          type,
          main_option_title: mainOption,
          extra_option_titles: extraOption
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };

        const appointmentsById = this.appointmentById[id]
          ? this.appointmentById[id]
          : quota == 0
          ? [
              {
                id: uuid.v4(),
                dateTime: null,
                serviceId: id,
                constraint: {
                  canMakeAppointment: true
                },
                dateTimeEnd: null,
                providerId: service.provider.id,
                actualCost: null
              }
            ]
          : [];

          const appointments = appointmentsById.map((appointment) => {
            const ISOdateTime = DateTime.fromISO(appointment.dateTime);
            const time = getDurationAppointmentTimeText(appointment.dateTime, appointment.dateTimeEnd);

            // disable ปุ่ม นัดหมาย ถ้าไม่ใช่การนัดครั้งแรกสุดที่ยังไม่ได้นัด
            let isDisableButton = false;

            let isDisableAppointmentByNoteInvoice = appointment.isDisableAppointmentByNoteInvoice
            if (
              this.detail.histories
              && this.detail.histories.length === 1
              && this.detail.histories[0].invoice
              && existValueAndEmptyString(
                this.detail.histories[0].invoice.is_disable_appointment_by_note_invoice
              )
              && quota == 0
            ) {
              isDisableAppointmentByNoteInvoice = this.detail
                .histories[0]
                .invoice
                .is_disable_appointment_by_note_invoice
            }

            return {
              id: appointment.id,
              invoice: (appointment.invoiceId!==undefined) ? appointment.invoiceId : null,
              purchasedAt: (appointment.purchasedAt!==undefined) ? appointment.purchasedAt : null,
              effectivedAt: (appointment.effectivedAt!==undefined) ? appointment.effectivedAt : null,
              documentNumber: (appointment.documentNumber!==undefined) ? appointment.documentNumber : null,
              appointmentNo: (appointment.appointmentNo!==undefined) ? appointment.appointmentNo: null,
              date: toLocaleTH(ISOdateTime).toFormat("dd MMM yyyy"),
              time,
              route: !appointment.constraint.canMakeAppointment
                ? { name: "AppointmentDetailPage", params: { id: appointment.id } }
                : null,
              canMakeAppointment: appointment.constraint.canMakeAppointment,
              isDisableButton,
              providerId: appointment.providerId,
              actualCost:  appointment.actualCost,
              isDisableAppointmentByNoteInvoice: isDisableAppointmentByNoteInvoice,
              canNotEditAppointmentCost: appointment.canNotEditAppointmentCost
            };
          })

          const histories = this.groupBy(appointments, "invoice");

          // enable appointment in each first appoint in each invoice
          Object.values(histories).forEach((history) => {
            history.sort((a, b) => (a.date < b.date) ? 1 : -1)
            history.sort((a, b) => (a.appointmentNo > b.appointmentNo) ? 1 : -1)
            Object.values(history).forEach((appointment, index) => {
              if (
                appointment.isDisableAppointmentByNoteInvoice
                && appointment.isDisableAppointmentByNoteInvoice === true
              ) {
                appointment.isDisableButton = true
              } else if (
                index === 0
                || Object.values(history)[index - 1].date !== 'Invalid DateTime'
              ) {
                appointment.isDisableButton = false
              } else {
                appointment.isDisableButton = true
              }
            })
          })

        return {
          id,
          data: {
            id,
            iconUrl,
            name,
            shortDescription,
            description,
            provider,
            quota,
            type,
            mainOption,
            extraOption
          },
          appointments,
          histories
        };
      });
    },
    isCallCenter() {
      return localStorage.getItem("adminRoleId") == 4;
    },
    showCancelAction() {
      if (this.isCallCenter) {
        return false;
      }

      return this.showCancelButton || this.showUnsubscribeButton;
    },
    showExpiredDate() {
      return this.status !== subscriptionStatus.EXPIRED;
    },
    showCancelButton() {
      return [
        subscriptionStatus.ACTIVE,
        subscriptionStatus.FREE_TRIAL
      ].includes(this.status);
    },
    showCancelledDate() {
      return [
        subscriptionStatus.CANCELLED,
        subscriptionStatus.UNSUBSCRIBED
      ].includes(this.status);
    },
    showUnsubscribeButton() {
      return subscriptionStatus.ACTIVE === this.status;
    },
    disabledUnsubscribeButton() {
      return !this.showUnsubscribeButton;
    },
    disabledCancelButton() {
      if (this.histories.length === 0) {
        return true;
      }

      const isReceiptSigned = this.histories[0].isReceiptSigned;

      return isReceiptSigned;
    },
    alertDialog() {
      switch (this.status) {
        case subscriptionStatus.FREE_TRIAL:
          return {
            isShow: true,
            message: "ลูกบ้านทดลองใช้งาน"
          };
        case subscriptionStatus.UNSUBSCRIBED:
          return {
            isShow: true,
            message: "ลูกบ้านไม่ Sub ต่อ"
          };
        case subscriptionStatus.CANCELLED:
          return {
            isShow: false,
            message: "ยกเลิกทันที"
          };
      }

      if (this.histories.length === 0) {
        return {
          isShow: false,
          message: ""
        };
      }

      const isReceiptSigned = this.histories[0].isReceiptSigned;

      if (!isReceiptSigned) {
        return {
          isShow: false,
          message: ""
        };
      }

      const isShow = isReceiptSigned;
      const date = this.histories[0].receiptSignedAt.toFormat(
        "dd MMM yyyy HH:mm"
      );

      const message = `ไม่สามารถ "ยกเลิกทันที" ได้ เนื่องจากออกใบเสร็จไปแล้ว เมื่อ ${date}`;
      return {
        isShow,
        message
      };
    },
    paymentStatus() {
      if (!this.payment) {
        return "กำลังโหลด";
      }

      if (this.payment === "F") {
        return "ไม่สามารถเรียกดูข้อมูลการชำระเงินได้";
      }

      return reversePaymentStatus[this.payment.status];
    },
    showPaymentStatus() {
      if (!this.status) {
        return false;
      }

      return (
        this.status !== subscriptionStatus.FREE_TRIAL && this.subscriber.invoice
      );
    },
    status() {
      if (this.detail === null) {
        return null;
      }

      const now = DateTime.utc();
      const isFreeTrial = Boolean(this.detail.trial);
      const isExpired = now > DateTime.fromISO(this.detail.expired_at).toUTC();

      const isUnsubscribed = !isFreeTrial && Boolean(this.detail.cancelled_at);
      const isCancelled = this.detail.cancelled_at === this.detail.expired_at;

      if (isCancelled) {
        return subscriptionStatus.CANCELLED;
      }

      if (isExpired) {
        return subscriptionStatus.EXPIRED;
      }

      if (isUnsubscribed) {
        return subscriptionStatus.UNSUBSCRIBED;
      }

      if (isFreeTrial) {
        return subscriptionStatus.FREE_TRIAL;
      }

      return subscriptionStatus.ACTIVE;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      try {
        await this.setupData();
        await this.setupAppointments();
        await this.setupProviders();
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message === "read ECONNRESET"
        ) {
          this.setup();
        }
        console.error(error);
      }
    },
    async setupData() {
      const data = await this.fetchData();
      this.detail = data;

      const id = data.id;
      const userId = data.owner.user_id;
      const userName = `${data.owner.first_name} ${data.owner.last_name}`;
      const phoneNumber = data.owner.mobile_number || "-";
      const email = data.owner.user.email;
      const isUserForOfflinePurchaseByAdmin = data.owner.is_user_for_offline_purchase_by_admin;
      const identifierNo =
        data.owner.citizen_id !== ""
          ? data.owner.citizen_id
          : data.owner.passport_number;
      const dateOfBirth = toLocaleTH(
        DateTime.fromISO(data.owner.birth_date)
      ).toFormat("dd MMMM yyyy");

      const home = {
        addressNumber: data.home ? data.home.address_no : "",
        project: data.project ? data.project.project_name : ""
      };
      const billingCycle =
        data.current_package.billing_cycle > 1
          ? " " + data.current_package.billing_cycle.toLocaleString() + " "
          : " ";
      const cycleUnit = data.current_package.billing_cycle === 0 ? "ครั้ง" : "เดือน";
      const quality = data.quality || 1;
      const price = data.total_price !== null && data.total_price >= 0
        ? convertBathToStangAndRoundTwoDecimal(data.total_price)
        : convertBathToStangAndRoundTwoDecimal(data.current_package.price) * quality;
      const totalPriceBeforeDiscount = formatCurrencyAndTwoDecimalsString(price);

      const billingCycleText = `${totalPriceBeforeDiscount} บาท /${billingCycle} ${cycleUnit}`;
      const pack = {
        name: data.current_package.name,
        price,
        billingCycle: billingCycleText
      };
      const format = "dd MMMM yyyy HH:mm น.";
      const purchasedAt = toLocaleTH(
        DateTime.fromISO(data.purchased_at)
      ).toFormat(format);
      const expiredAt = toLocaleTH(DateTime.fromISO(data.expired_at)).toFormat(
        format
      );
      const cancelledAt = data.cancelled_at
        ? toLocaleTH(DateTime.fromISO(data.cancelled_at)).toFormat(format)
        : null;
      const invoice = data.invoice
        ? {
            id: data.invoice.id.toString().padStart(12, "0")
          }
        : undefined;
      const receipt = data.receipt
        ? {
            id: data.receipt.id.toString().padStart(12, "0"),
            signedAt:
              data.receipt && data.receipt.signed_at
                ? toLocaleTH(DateTime.fromISO(data.receipt.signed_at)).toFormat(
                    "dd MMMM yyyy HH:mm น."
                  )
                : null
          }
        : data.receipt;
      const services = data.services.map(service => {
        const {
          id,
          name,
          short_description: shortDescription,
          description,
          icon: iconUrl,
          type,
          main_option_title: mainOption,
          extra_option_titles: extraOption
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };

        return {
          id,
          iconUrl,
          name,
          shortDescription,
          description,
          provider,
          type,
          mainOption,
          extraOption
        };
      });

      const effectivedAt = toLocaleTH(
        DateTime.fromISO(data.effectived_at)
      ).toFormat("dd MMMM yyyy HH:mm น.");
      const qualityText = `จำนวน ${data.quality || 1} แพ็คเกจ`;

      const subscriber = {
        id,
        userId,
        name: userName,
        phoneNumber,
        email,
        identifierNo,
        dateOfBirth,
        home,
        package: pack,
        purchasedAt,
        expiredAt,
        cancelledAt,
        effectivedAt,
        invoice,
        receipt,
        services,
        qualityText,
        qualityUnit: `จำนวน ${quality} หน่วย`,
        isUserForOfflinePurchaseByAdmin
      };

      this.subscriber = subscriber;
    },
    async setupAppointments() {
      const data = await this.fetchAppointments();
      const appoints = toCamelCaseObject(data);

      const appointments = appoints.map((appointment) => {
        return {
          ...appointment,
          actualCost: appointment.actualCost !== null && appointment.actualCost >= 0
            ? convertBathToStangAndRoundTwoDecimal(appointment.actualCost)
            : null,
          canNotEditAppointmentCost: appointment.is_generate_sap_mm_report === true
        }
      })

      this.appointmentById = this.groupBy(appointments, "serviceId");
    },
    async fetchData() {
      const { id } = this.$route.params;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.get(
          id
        );

        return response.data.result;
      } catch (error) {
        alert("ไม่สามารถเรียกดูข้อมูลได้ กรุณาลองใหม่");
        throw error;
      }
    },
    async fetchAppointments() {
      const { id } = this.$route.params;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.getAppointments(
          id
        );

        return response.data.result;
      } catch (error) {
        alert("ไม่สามารถเรียกดูข้อมูลได้ กรุณาลองใหม่");
        throw error;
      }
    },
    async handleClickBookService(service, appointment) {
      if (service.data.quota === 0 && !confirm("คุณกำลังนัดหมาย 'สินค้า' เมื่อกดบันทึกจะ 'ปิดงาน' ให้ทันที")) {
        return;
      }

      this.confirmDialog.isShow = true;
      this.form.service = service;
      this.form.appointment = appointment;
      this.confirmDialog.disableSubmit = false;
    },
    async handleConfirm(isConfirm) {
      this.confirmDialog.disableSubmit = true;

      if (!isConfirm) {
        this.confirmDialog.isShow = false;
        this.form.service = null;
        this.form.appointment = null;
        this.form.dateTime = null;
        this.form.timeStart = null;
        this.form.timeEnd = null;
        return;
      }

      if (!this.form.timeStart) {
        alert('โปรดเลือก เวลาที่เริ่ม');
        return;
      }

      try {
        const { dateTime, timeStart, timeEnd } = this.form;
        const { id: serviceId, quota } = this.form.service.data;
        const { id: appointmentId } = this.form.appointment;
        const { id: providerId } = this.form.service.data.provider;
        const {
          id: subscriptionId,
          home_id: homeId,
          project_id: projectId,
          owned_by: userId
        } = this.detail;

        let timeStartSetFormat = timeStart

        if (timeStart instanceof DateTime) {
          timeStartSetFormat = timeStart.toJSDate()
        }

        const date = dateTime.setZone("utc+7").set({
          hours: timeStartSetFormat.getHours(),
          minutes: timeStartSetFormat.getMinutes(),
        });

        if (quota == 0) {
          const form = {
            dateTime: date,
            serviceId: serviceId.toString(),
            providerId: providerId.toString(),
            homeId,
            projectId,
            userId: userId.toString(),
            subscriptionId,
            dateTimeEnd: timeEnd || undefined,
            isFulfillAppointment: true
          };

          await baanRueJaiClient.admin.subscriptions.appointments.postCreate(
            form
          );
        } else {
          await baanRueJaiClient.admin.subscriptions.appointments.updateEmpty(
            appointmentId,
            {
              date_time: date,
              date_time_end: timeEnd || undefined
            }
          );
        }

        await this.setupAppointments();
        this.confirmDialog.isShow = false;
        this.form.service = null;
        this.form.appointment = null;
        this.form.dateTime = null;
        this.form.timeStart = null;
      } catch (error) {
        console.error(error);
        alert("ไม่สามารถนัดวันได้");
      }

      this.confirmDialog.disableSubmit = false;
    },
    handleChangeDateTime(dateTimeSelect) {
      if (!dateTimeSelect) {
        this.form.dateTime = null;
        this.form.timeStart = null;
        this.form.timeEnd = null;
        return
      }

      const updatedDateTime = dateTimeSelect.setZone("utc+7");
      this.form.dateTime = updatedDateTime.toUTC();

      const now = DateTime.now();
      const isMorningTime = now < now.set({ hour: 12});

      this.form.timeStart = isMorningTime
        ? updatedDateTime.set({ hour: 9 })
        : updatedDateTime.set({ hour: 13 })

      this.form.timeEnd = isMorningTime
        ? updatedDateTime.set({ hour: 12 })
        : updatedDateTime.set({ hour: 16 })
    },
    isFastFixServiceType(serviceType) {
      return serviceType === "FAST_FIX";
    },
    groupBy (xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    handleChangeTime(time, type) {
      const isStartTime = type === 'START'
      if (!time) {
        if (isStartTime) this.form.timeStart = null;
        if (!isStartTime) this.form.timeEnd = null;
      }

      if (isStartTime) {
        this.form.timeStart = time;
      } else {
        this.form.timeEnd = time;
      }
    },
    async setupProviders() {
      const providerList = await this.fetchProviders();

      this.providers = providerList.map(provider => {
        const {
          id,
          name,
          icon_url: logoUrl = "https//placehold.it/64",
          is_vat_registered: isVatRegistered
        } = provider;

        return {
          id: id,
          name,
          logoUrl,
          isVatRegistered
        };
      });
    },
    async fetchProviders() {
      const response = await baanRueJaiClient.admin.subscriptions.providers.list();

      return response.data.result;
    },
    async handleChangeProvider(
      appointmentId,
      newProviderId,
      actualCost
    ) {
      const newProvider = this.providers.find((provider) => provider.id === newProviderId)

      if (!newProvider) return

      if (confirm(`ยืนยันการเปลี่ยนผู้ให้บริการเป็น ${newProvider.name}`)) {
        const params = {
          actual_cost: actualCost !== null && actualCost >= 0
            ? convertStangToBathAndRoundTwoDecimal(actualCost)
            : null,
          provider_id: newProviderId
        }

        try {
          await baanRueJaiClient.admin.subscriptions.appointments.updateProviderAndActualCost(
            appointmentId,
            params
          );
        } catch(err) {
          console.log(err)
          alert('ไม่สามารถบันทึกผู้ให้บริการได้');
        }

        await this.setupAppointments();
      }
    },
    async handleEnterEditActualCost(appointmentId, actualCost, providerId) {
      if (confirm(`ต้องการเปลี่ยนราคาต้นทุนจริงเป็น ${actualCost}บาท หรือไม่`)) {
        const params = {
          actual_cost: actualCost !== null && actualCost >= 0
            ? convertStangToBathAndRoundTwoDecimal(actualCost)
            : null,
          provider_id: +providerId
        }

        try {
          await baanRueJaiClient.admin.subscriptions.appointments.updateProviderAndActualCost(
            appointmentId,
            params
          );
        } catch(err) {
          console.log(err)
          alert('ไม่สามารถบันทึกราคาต้นทุนจริงได้');
        }

        await this.setupAppointments();
      }
    },
    handleEditActualCost(serviceId, appointmentId, actualCost) {
      if (
        this.appointmentById
        && this.appointmentById[serviceId]
        && this.appointmentById[serviceId].length > 0
      ) {
        this.appointmentById[serviceId].forEach((t) => {
          if (t.id === appointmentId) {
            t.actualCost = actualCost
          }
        })
      } else {
        alert('ไม่สามารถแก้ไขต้นทุนจริงได้');
      }
    },
    async handleDecryptIdCard() {
      try {
        const subscriber_id = this.subscriber.id;
        const response = await backendAdminClient.subscriber.getDecryptedIdCard(subscriber_id);
        
        this.subscriber.identifierNo = response.data.result.id_card;
        this.isButtonHidden = true;
      } catch (error) {
        alert("ไม่สามารถเข้าถึงได้");
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.info {
  border-left: $border;
}

.member h6,
.info h6 {
  margin-bottom: 20px;
}

.history {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: $border;

  font-size: 14px;

  .no {
    font-size: 16px;
    font-weight: bold;
  }
}

.view-receipt {
  display: inline-block;

  border-radius: $border-radius;
  border: $border;
  min-width: 0px;
  padding: 6px $space/ 2;

  font-size: 1rem;
  text-align: center;
  background: white;
  cursor: pointer;
  font-size: 14px;

  &:hover:not(:disabled) {
    border-color: $primary-color;

    text-decoration: none;

    background: #eee;
  }

  &:focus:not(:disabled) {
    outline: 0;

    border-color: $primary-color;
  }
}

.service-item {
  border-bottom: 0 !important;
}

.provider-selector {
  width: 100%;
}

.provider-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.appointment-title {
  font-size: 13px;
  color: rgb(107, 106, 106);
}

.font-red {
  color: rgb(250, 102, 102);
}


.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/pages/SubscriberBookServicePage.vue